import React from "react";
import { DashboardMainHeader } from "../DataGuardCommonComponents";


function DetailPageHeader({selected, setSelected, children}) {
  return (
    <div>
      <DashboardMainHeader title="DataGuard Overview" loc="detailsPage" selected={selected} setSelected={setSelected}>
        {children}
      </DashboardMainHeader>
    </div>
  );
}

export default DetailPageHeader;
